import { render, staticRenderFns } from "./NotificacaoLogTabela.vue?vue&type=template&id=19b53dde"
import script from "./NotificacaoLogTabela.vue?vue&type=script&lang=js"
export * from "./NotificacaoLogTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports